<template>
<div class="modal fade" id="modalBulkUpdateCompanyFlags" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Edição em massa — Empresas</h4>
        <p class="subtitle-modal">
          Operação destrutiva. As mudanças são aplicadas em <strong>{{ companyIds.length }}</strong>
          empresa(s) selecionada(s). Cada flag é opcional: só altera quem
          for marcada.
        </p>
      </div>

      <div class="modal-body">
        <div class="bulk-row">
          <label class="bulk-toggle">
            <input type="checkbox" v-model="changeBlocked"/>
            Alterar <strong>MarQboard bloqueada</strong>
          </label>
          <select v-model="isBlockedMarqboard" :disabled="!changeBlocked">
            <option :value="true">Bloquear</option>
            <option :value="false">Desbloquear</option>
          </select>
        </div>

        <div class="bulk-row">
          <label class="bulk-toggle">
            <input type="checkbox" v-model="changeDefault"/>
            Alterar <strong>Inadimplente (Default)</strong>
          </label>
          <select v-model="defaultInadimplente" :disabled="!changeDefault">
            <option :value="true">Marcar inadimplente</option>
            <option :value="false">Remover inadimplência</option>
          </select>
        </div>

        <hr/>

        <div class="form-group">
          <label>Senha de confirmação</label>
          <input type="password" v-model="password" placeholder="Digite a senha de operação"/>
        </div>

        <div v-if="error" class="error-msg">{{ error }}</div>
      </div>

      <div class="modal-footer">
        <button class="btn-cancel" v-on:click="closeModal()">Cancelar</button>
        <button class="btn-danger" v-on:click="submit()"
                :disabled="loading || !canSubmit">
          <span v-if="!loading">Aplicar</span>
          <span v-else>Aplicando...</span>
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { BULK_UPDATE_COMPANY_FLAGS } from "../../../urlConfig";
import { REQUEST_SERVICE } from "../../../requestConfig";
import swal from "sweetalert";

export default {
  name: "modalBulkUpdateCompanyFlags",
  props: {
    companyIds: { type: Array, default: () => [] }
  },
  data() {
    return {
      changeBlocked: false,
      isBlockedMarqboard: true,
      changeDefault: false,
      defaultInadimplente: true,
      password: "",
      loading: false,
      error: ""
    };
  },
  computed: {
    canSubmit() {
      return (this.changeBlocked || this.changeDefault) && this.password && this.companyIds.length > 0;
    }
  },
  methods: {
    closeModal() {
      $("#modalBulkUpdateCompanyFlags").modal("toggle");
    },
    submit() {
      this.error = "";
      if (!this.canSubmit) return;
      this.loading = true;

      const payload = {
        companyIds: this.companyIds,
        password: this.password,
        isBlockedMarqboard: this.changeBlocked ? this.isBlockedMarqboard : null,
        default: this.changeDefault ? this.defaultInadimplente : null
      };

      REQUEST_SERVICE.post(BULK_UPDATE_COMPANY_FLAGS, payload)
        .then((response) => {
          this.loading = false;
          this.password = "";
          swal("Sucesso", `${response.data.affected} empresa(s) atualizada(s).`, "success");
          $("#modalBulkUpdateCompanyFlags").modal("toggle");
          this.$emit("done");
        })
        .catch((reason) => {
          this.loading = false;
          const status = reason && reason.response && reason.response.status;
          if (status === 403) {
            this.error = "Senha incorreta.";
          } else {
            this.error = "Falha na operação. Verifique os dados.";
          }
        });
    }
  }
};
</script>

<style lang="scss">
#modalBulkUpdateCompanyFlags {
  .modal-header { padding: 15px 15px 0; border-bottom: none; }
  .title-modal {
    text-align: center; font-weight: bold; padding-top: 10px;
    letter-spacing: 1px; text-transform: uppercase;
  }
  .subtitle-modal {
    text-align: center; color: #777; font-size: 13px;
    padding: 0 30px; margin-top: 8px;
  }
  .modal-body { padding: 20px 40px; }

  .bulk-row {
    display: flex; gap: 12px; align-items: center; margin-bottom: 14px;
    .bulk-toggle {
      flex: 1; display: inline-flex; align-items: center; gap: 6px;
      font-weight: 500; margin: 0; cursor: pointer;
    }
    select {
      border: 1px solid #ccc; border-radius: 4px; padding: 6px 10px;
      min-width: 200px;
    }
    select[disabled] { opacity: 0.5; cursor: not-allowed; }
  }

  .form-group label { font-weight: 600; margin-bottom: 4px; display: block; }
  .form-group input {
    width: 100%; border: 1px solid #ccc; border-radius: 4px; padding: 8px 12px;
  }

  .error-msg { color: #e74a4e; margin-top: 12px; font-size: 13px; text-align: center; }

  .modal-footer {
    .btn-cancel {
      border-radius: 4px; background: #8b8787; color: #fff;
      padding: 7px 22px; border: none; font-weight: 600;
    }
    .btn-danger {
      border-radius: 4px; background: #c0392b; color: #fff;
      padding: 7px 22px; border: none; font-weight: 600; margin-left: 8px;
    }
    .btn-danger:disabled { opacity: 0.5; cursor: not-allowed; }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalBulkUpdateCompanyFlags.vue